/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Copy_FailedInputs */

const en_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode copy failed`)
};

const fr_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la copie des timecodes`)
};

const de_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode-Kopie fehlgeschlagen`)
};

const it_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia del timecode non riuscita`)
};

const ru_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирование временного кода не удалось.`)
};

const es_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error en la copia del código de tiempo`)
};

const zh_cn2_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码复制失败`)
};

const ja_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードのコピーに失敗しました`)
};

const hi_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड कॉपी करने में विफलता`)
};

const pt_pt2_timecode_copy_failed = /** @type {(inputs: Timecode_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A cópia do código de tempo falhou`)
};

/**
* | output |
* | --- |
* | "Timecode copy failed" |
*
* @param {Timecode_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_copy_failed = /** @type {((inputs?: Timecode_Copy_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Copy_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timecode_copy_failed(inputs)
	if (locale === "de") return de_timecode_copy_failed(inputs)
	if (locale === "it") return it_timecode_copy_failed(inputs)
	if (locale === "ru") return ru_timecode_copy_failed(inputs)
	if (locale === "es") return es_timecode_copy_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_timecode_copy_failed(inputs)
	if (locale === "ja") return ja_timecode_copy_failed(inputs)
	if (locale === "hi") return hi_timecode_copy_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_timecode_copy_failed(inputs)
	return en_timecode_copy_failed(inputs)
});